export async function syncLocalData(networkData) {
  return localStorage.setItem("data", JSON.stringify(networkData));
}
